import { ApiParams, ApiResponse } from '@models/api.model.ts';
import axiosInstance from '@api/axios-instance.ts';
import { ServicesModel } from '@models/services.model.ts';

export const getServices = async (
  params?: ApiParams
): Promise<ApiResponse<ServicesModel>> => {
  const response = await axiosInstance.get('/pms/services/getter', { params });
  return response.data;
};

export const getServicesList = async (): Promise<any> => {
  const response = await axiosInstance.get('/pms/services');
  return response.data;
};

export const createService = async (body: any): Promise<ServicesModel> => {
  return await axiosInstance.post(`/pms/services`, body);
};

export const editService = async (
  body: any,
  id: number
): Promise<ServicesModel> => {
  return await axiosInstance.put(`/pms/services/${id}`, body);
};

export const deleteService = async (id: number): Promise<void> => {
  return await axiosInstance.delete(`/pms/services/${id}`);
};

export const togglePublish = async (id: number): Promise<any> => {
  const response = await axiosInstance.put(`/pms/services/toggle/${id}`);
  return response.data;
};
